var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-frappe',{attrs:{"id":"test","type":"bar","isNavigable":true,"height":300,"labels":_vm.labels,"colors":['green', 'blue'],"dataSets":this.results,"tooltipOptions":{
            formatTooltipY: d => 'GMD ' + _vm.formatPrice(d),
        }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }